import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

import { NOTIFICATION_KEYS } from '../PdpSharedNotifications/pdpSharedNotificationConstants';
import { TradeOnboardingCoachmarkConditionalLoader } from '../../global/tradeOnboarding/TradeOnboardingCoachmarkConditionalLoader';

import { hasSubmittedDesignManagerUpgradeRequest } from '../../global/tradeOnboarding/tradeDesignManagerOnboardingRules';
import { connect } from 'react-redux';

import { TradeDesignManagerPdpLauncher } from 'dibs-trade-design-manager/exports/TradeDesignManagerPdpLauncher';
import { DESIGN_MANAGER_UPGRADE_SUBMITTED } from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';

import styles from './PdpRespIconBubbles.scss';

import {
    pdpCoachmarkMaxViewsExceeded,
    getPdpTooltipDismissed,
} from '../PdpRespTradeOnboardingCoachmark/helpers';

import { DESIGN_MANAGER_PRO } from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';

// helpers
import get from 'lodash.get';

export const DESIGN_MANAGER_UPGRADED = 'DESIGN_MANAGER_UPGRADED';

export const PdpRespIconBubbleDesignManagerComponent = props => {
    const regularOnboardingExperienceExpired =
        pdpCoachmarkMaxViewsExceeded() || getPdpTooltipDismissed();

    const {
        item,
        user,
        skuId,
        showPdpTradeDesignManagerProOnboardingModal,
        showPdpTradeDesignManagerStandardOnboardingModal,
    } = props;

    const isProAccount =
        get(user, 'tradeFirmDesignManagerProfile.accountType') === DESIGN_MANAGER_PRO || false;

    // If user is upgraded to PRO, update the flag to help signal that Pro DM Onboarding Coachmark and
    // On-approval coachmark should not show up at the same time
    if (isProAccount && hasSubmittedDesignManagerUpgradeRequest()) {
        localStorage.setItem(DESIGN_MANAGER_UPGRADE_SUBMITTED, DESIGN_MANAGER_UPGRADED);
    }

    const coachmark = regularOnboardingExperienceExpired ? (
        isProAccount ? (
            <TradeOnboardingCoachmarkConditionalLoader
                isDesignManagerPro
                user={user}
                showModal={showPdpTradeDesignManagerProOnboardingModal}
            />
        ) : (
            <TradeOnboardingCoachmarkConditionalLoader
                isDesignManagerStandard
                user={user}
                showModal={showPdpTradeDesignManagerStandardOnboardingModal}
            />
        )
    ) : null;

    return (
        <div className={styles.designManagerBubbleDiv}>
            {coachmark}
            <TradeDesignManagerPdpLauncher item={item} user={user} skuId={skuId} />
        </div>
    );
};

PdpRespIconBubbleDesignManagerComponent.propTypes = {
    relay: PropTypes.object,
    item: PropTypes.object.isRequired,
    skuId: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    showPdpTradeDesignManagerProOnboardingModal: PropTypes.bool,
    showPdpTradeDesignManagerStandardOnboardingModal: PropTypes.bool,
};

function mapStateToProps(state) {
    const notifications = get(state, 'sharedNotificationsReducer.notifications') || {};
    return {
        showPdpTradeDesignManagerProOnboardingModal:
            notifications[NOTIFICATION_KEYS.PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING] || false,
        showPdpTradeDesignManagerStandardOnboardingModal:
            notifications[NOTIFICATION_KEYS.PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING] || false,
    };
}

export const PdpRespIconBubbleDesignManager = createFragmentContainer(
    connect(mapStateToProps)(PdpRespIconBubbleDesignManagerComponent),
    {
        item: graphql`
            fragment PdpRespIconBubbleDesignManager_item on Item {
                ...TradeOnboardingCoachmarkConditionalLoader_item
                ...TradeDesignManagerPdpLauncher_item
            }
        `,
        user: graphql`
            fragment PdpRespIconBubbleDesignManager_user on User {
                tradeFirmDesignManagerProfile {
                    hasAccount
                    accountType
                }
                ...TradeOnboardingCoachmarkConditionalLoader_user
                ...TradeDesignManagerPdpLauncher_user
            }
        `,
    }
);
